<template>
  <div class="checkin">
    <checkin-stepper/>
    <v-container class="checkin">
      <v-card>
        <v-card-text>
          <div v-if="loading" class="text-center">
            <v-progress-circular
              size="50"
              color="primary"
              indeterminate
            />
          </div>

          <div v-else-if="contractError || error_contract_loaded_timeout" class="text-center">
            <h4>{{ $t('reservation.customer_contract_state_error') }}</h4>
            <p>{{ $t('reservation.customer_contract_state_error_hint') }}</p>
            <v-expansion-panels class="text-left">
              <v-expansion-panel class="text-left">
                <v-expansion-panel-header>{{$t('reservation.show_log_title') }}</v-expansion-panel-header>
                <v-expansion-panel-content class="text-left">
                  <v-btn
                    elevation="2"
                    @click="copy_error_text"
                  > <v-icon>mdi-clipboard-multiple-outline</v-icon> Copy</v-btn>
                  <br><br>
                  <p class="text-left" id = "contract_error_text">
                    {{
                      {
                        reservation: this.reservation ? "yes" : "no",
                        contract_state: this.reservation.customer_contract_state ? this.reservation.customer_contract_state : "empty",
                        selected_guest_uuid: this.selectedGuestUuid ? this.selectedGuestUuid : "empty",
                        reservation_object_signer_uuid: this.reservation.signer_uuid ? this.reservation.signer_uuid : "empty",
                        otp_url: this.$store.state.application.urls.public_contract_to_sign ? this.$store.state.application.urls.public_contract_to_sign : "empty",
                        contract_url: contract_url? contract_url : 'empty',
                        timeout_triggered: this.error_contract_loaded_timeout ? "yes" : "no",
                        manualError: this.manualError,
                        contractError: this.contractError,
                        socket_info_status: {
                          connected: this.sock_connected,
                          rejected: this.sock_rejected,
                          received: this.sock_received,
                          disconnected: this.sock_disconnected,
                          data: this.sock_data ? this.sock_data : "empty",
                        },
                      }
                    }}
                  </p>

                  <!-- p class="text-left">
                    {{$t('reservation.error_logs_title') }}<br>
                    {{$t('reservation.reservation_exists') }}{{this.reservation ? "yes" : "no"}}<br>
                    {{$t('reservation.contract_state') }}{{this.reservation.customer_contract_state ? this.reservation.customer_contract_state : "empty"}}<br>
                    {{$t('reservation.url_in_options') }}{{this.$store.state.application.urls.public_contract_to_sign ? this.$store.state.application.urls.public_contract_to_sign : "empty"}}<br>
                    {{$t('reservation.selected_uuid') }}{{this.selectedGuestUuid ? this.selectedGuestUuid : "empty"}}<br>
                    {{$t('reservation.reservation_uuid') }}{{this.reservation.signer_uuid ? this.reservation.signer_uuid : "empty"}}<br>
                    {{$t('reservation.contract_url') }}{{this.contract_url ? this.contract_url : "empty"}}<br>
                    timeout triggered: {{this.error_contract_loaded_timeout ? "yes" : "no"}}<br>
                    ----<br>
                    Socket pass:<br>
                    Connected: {{ this.sock_connected }}<br>
                    Rejected: {{ this.sock_rejected }}<br>
                    Received: {{ this.sock_received }}<br>
                    Data (if received): {{ this.sock_data ? this.sock_data : "empty"}}<br>
                    Disconnected: {{ this.sock_disconnected }}<br>
                  </p -->

                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <p></p>
            <v-icon>mdi-alert-circle</v-icon>
          </div>

          <div v-else-if="manualError" class="text-center">
            <h4>{{ $t('reservation.customer_manual_state_error') }}</h4>
            <p>{{ $t('reservation.customer_manual_state_error_hint') }}</p>
            <v-icon>mdi-alert-circle</v-icon>
          </div>

          <div v-else-if="isGuestsRecognitionActive && !bookedChief" class="text-center">
            <h4>{{ $t('reservation.customer_contract_all_guests_required') }}</h4>
            <p>{{ $t('reservation.customer_contract_all_guests_required_hint') }}</p>
            <v-icon>mdi-backspace</v-icon>
          </div>

          <div v-else-if="!bookedChief" class="text-center">
            <h4>{{ $t('reservation.customer_contract_chief_guest_not_present') }}</h4>
            <p>{{ $t('reservation.customer_contract_chief_guest_not_present_hint') }}</p>
            <v-icon>mdi-backspace</v-icon>
          </div>

          <div v-else-if="contractCompleted" class="text-center">
            <h4>{{ $t('reservation.customer_contract_state_already_signed') }}</h4>
            <p>{{ $t('reservation.customer_contract_state_already_signed_hint') }}</p>
            <v-icon>mdi-thumb-up</v-icon>
          </div>

          <div v-else-if="areFilledAdvancedData" class="text-center">
            <h4>{{ $t('reservation.customer_contract_state_identifying') }}</h4>
            <p>{{ $t('reservation.customer_contract_state_identifying_hint') }}</p>
            <!--p v-if="awaitingResultButAttemptsExhausted">
              <v-btn large
                     color="primary"
                     @click='fetchOrder(order.id)'>{{ $t('commons.update') }}<v-icon>mdi-reload</v-icon></v-btn>
            </p-->
            <div v-if="bookedGuestsCount > 1">
              <p>{{ $t('reservation.customer_contract_state_identifying_with_others_guests_hint') }}</p>
              <div class="guests-grid">
                <v-row v-for="guest in reservation.guests" :key="guest.otpservice_uuid" >
                  <v-col cols="12" xs="12" sm="4">
                    {{ `${guest.first_name} ${guest.last_name}` }}
                  </v-col>
                  <v-col cols="12" xs="12" sm="4">
                    <v-chip class="ma-1" :color="hasGuestFilledAdvancedData(guest.otpservice_state) ? 'success' : 'grey'">
                      {{ guest.otpservice_state ? $t(`reservation.attributes.contract_states.${guest.otpservice_state}`) : ' ? ' }}
                    </v-chip>
                  </v-col>
                  <v-col v-if="hasGuestFilledAdvancedData(guest.otpservice_state)" cols="12" xs="12" sm="4">
                    <v-icon small grey>mdi-thumb-up</v-icon>
                  </v-col>
                  <v-col v-else-if="guest.otpservice_uuid"  cols="12" xs="12" md="4">
                    <v-btn @click="selectedGuestUuid = guest.otpservice_uuid" target="_blank" class="ml-1">
                      {{ $t('reservation.customer_contract_perform_recognition') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>

          <div v-else-if="contract_url">
            <div class="text-center">
              {{ $t('reservation.customer_contract_redirecting') }}
              <a :href="contract_url">
                {{ $t('reservation.customer_contract_redirecting_anchor') }}
              </a>
            </div>
            <div class="text-center mt-5 mb-3">
              <v-progress-circular
                size="40"
                color="secondary"
                indeterminate
              />
            </div>
          </div>

          <div v-else-if="updatingOrderForContractUrl">
            <div class="text-center">
              <p>{{ `${$t('reservation.customer_contract_wait_generating')}` }}</p>
              <v-progress-circular
                size="40"
                color="secondary"
                indeterminate
              />
            </div>
          </div>

          <div v-else class="text-center">
            <p>{{ $t('errors.impossible_show_contract', {code: reservation.signer_uuid ? `FASTNOC${reservation.id}` : `FASTNOS${reservation.id}`}) }}</p>
            <v-btn
              icon
              @click="prevGuest({clearMsg: true})"
              :disabled="!hasPrevGuest || formIsDirty"
              v-visible="hasPrevGuest"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn
              large
              color="primary"
              @click='fetchOrder(order.id)'
            >
              {{ $t('commons.retry') }}
              <v-icon>mdi-reload</v-icon>
            </v-btn>
          </div>
        </v-card-text>

        <checkin-bottom-navigation>
          <template v-slot:prev-button>
            <v-btn @click="goToPrevStepper">
              {{ $t("commons.prev") }}
            </v-btn>
          </template>
        </checkin-bottom-navigation>
      </v-card>
    </v-container>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { orderFetchMixin } from '../../../mixins/order_fetch_mixin'
  import { reservationMixin } from '../../../mixins/reservation_mixin'
  import { guestMixin } from '../../../mixins/guest_mixin'
  import { orderMethodsMixin } from '../../../mixins/order_methods_mixin'
  import CheckinStepper from '../../checkin/checkin_stepper'
  import CheckinBottomNavigation from '../../checkin/checkin_bottom_navigation'

  // const contractAttemptsFrequency = 5000
  // const contractMaxAttempts = 10
  // const contractStateAttemptsFrequency = 2000
  // Calcoliamo i tentativi in base alla frequenza per garantire un retry di 10 minuti (600 sec)
  // const contractStateMaxAttempts = 600 / (contractStateAttemptsFrequency / 1000)
  // const contractStateMaxAttempts = 70 // Sono i tentativi per circa 6 minuti (ogni 5 sec)
  // const startUpdatingContractStateAfter = 25000 // Dopo questi ms inizia l'autoupdater

  export default {
    name: "CheckinContract",

    props: {
      serverPort: {
        type: Number,
        default: 80
      }
    },

    components: {
      CheckinStepper,
      CheckinBottomNavigation
    },

    mixins: [
      orderFetchMixin,
      reservationMixin,
      orderMethodsMixin,
      guestMixin,
    ],

    data() {
      return {
        // contractAttempts: 1,
        // contractStateAttempts: 1,
        selectedGuestUuid: null,
        error_contract_loaded_timeout: false,
        sock_connected: false,
        sock_rejected: false,
        sock_received: false,
        sock_disconnected: false,
        sock_data: null,
      }
    },

    created() {
      this.fetchOrder(this.currentOrderId, this.getFreshOrder).then(() => {
        this.$cable.subscribe({
          channel: 'GuestsChannel',
          room: this.order.uuid
        })

        if (this.contract_url && this.contract_url !== '' && !this.contractCompleted) {
          this.redirectToContactUrl()
        }
      })

      // Hides not loaded iframe tips after x seconds
      setTimeout(() => {
        if ((this.contractError===true && this.manualError===false) || this.contract_url===false) {
          console.log("Timeout caricamento contratto")
          this.error_contract_loaded_timeout = true
        }
      }, 60000)

      // Don't use the autoupdater because it stucks the entire web app, use the action cable channel instead
      // if (this.bookedGuestsReached) this.autoUpdateOrderForShowContract()
      if(this.currentStep !== 6) {
        setTimeout(() => {
          this.goToStepper(6)
        }, 1000)
      }
    },
    computed: {
      ...mapState('layout', ['loading', 'submitting']),
      ...mapState('order', ['order']),
      ...mapState('layout', ['completedCheckinSteps']),

      contract_url() {
        if (!this.reservation || !this.reservation.signer_uuid) {
          console.log("Nessun signer uuid o reservation trovato")
          return false
        }
        if (!this.selectedGuestUuid) this.selectedGuestUuid = this.reservation.signer_uuid
        // const url = this.$store.state.application.urls.public_contract_to_sign
        // if (!url || !this.reservation.signer_uuid) return
        // return url.replace(':signer_uuid', this.reservation.signer_uuid)
        return this.build_contract_url(this.selectedGuestUuid)
      },
      formAndMandatoryStepsCompleted() {
        return this.completedCheckinSteps && this.completedCheckinSteps.every((step) => (step.mandatory || typeof(step.mandatory) == 'undefinded') ? step.completed : true)
      },
      // Mixin override
      getFreshOrder() {
        // Ask fresh order if contract is still to sign
        return this.reservation ? !this.contractCompleted : true
      },
      updatingOrderForContractUrl() {
        return !this.contract_url //&& this.contractAttempts <= contractMaxAttempts
      },
      updatingOrderReservation() {
        return !(this.contractCompleted) //&& this.contractStateAttempts <= contractStateMaxAttempts
      },
      // awaitingResultButAttemptsExhausted () {
      //   return !(this.contractCompleted || this.contractFilledForIdentification) && this.contractStateAttempts > contractStateMaxAttempts
      // },
      // contractStateAttemptsFrequency() {
      //   // The first attempt wait a bit more while guest is filling the form...
      //   return this.contractStateAttempts == 1 ? startUpdatingContractStateAfter : contractAttemptsFrequency
      // },
      areFilledAdvancedData() {
        // If a guest is selected, recognition is performed on the same device
        return !!this.reservation && this.contractCompleted || (this.isChiefRoomGuestSelected && this.hasGuestInGuestsFilledAdvancedData(this.reservation.signer_uuid))
      },
      isGuestsRecognitionActive() {
        return !!this.reservation && this.reservation.guests_recognition
      },
      isChiefRoomGuestSelected() {
        return this.selectedGuestUuid == this.reservation.signer_uuid
      },
      isChiefRoomGuestSigned() {
        return !!this.chiefRoomGuest && this.hasGuestFilledAdvancedData(this.chiefRoomGuest.otpservice_state)
      },
      contractCompleted() {
        return !!this.reservation && ['sent'].includes(this.reservation.customer_contract_state)
      },
      contractError() {
        return !!this.reservation && this.reservation.customer_contract_state === 'error'
      },
      manualError() {
        return !!this.reservation && this.reservation.customer_contract_state === 'manual'
      },
    },

    watch: {
      contract_url(newContractUrl, oldContractUrl) {
        if (newContractUrl && newContractUrl !== '' && oldContractUrl != newContractUrl && !this.contractCompleted) {
          this.redirectToContactUrl()
        }
      }
    },

    methods: {
      ...mapActions('layout', ['goToPrevStepper', 'goToNextStepper']),
      ...mapActions('layout', ['goToStepper']),

      redirectToContactUrl() {
        setTimeout(() => {
          window.location.href = this.contract_url
        }, 3000)
      },

      copy_error_text () {
        /* Get the text field */
        var copyText = document.getElementById("contract_error_text");

        /* Select the text field */
        //copyText.select();
        //copyText.setSelectionRange(0, 99999); /* For mobile devices */

        /* Copy the text inside the text field */
        navigator.clipboard.writeText(copyText.innerHTML);
      },
      // autoUpdateOrderForShowContract() {
      //   if (this.contract_url) this.autoUpdateOrderReservation()
      //   if (this.updatingOrderForContractUrl) {
      //     setTimeout(() => {
      //       this.contractAttempts += 1
      //       if (this.contract_url && this.contractStateAttempts == 1) this.autoUpdateOrderReservation()
      //       if (!this.updatingOrderForContractUrl) return
      //       this.fetchOrder(this.order.id).then(_ => {
      //         this.autoUpdateOrderForShowContract()
      //       })
      //     }, contractAttemptsFrequency)
      //   }
      // },
      // Non è efficace per il pulsante, sono tanti tentativi (tutto il tempo della firma) ma soprattutto e il recupero
      // dell'ordine rimpiazza l'oggetto nello stato e compromette l'operatività. Deve essere fatta una nuova fetch
      // che recupera solo lo stato dell'ordine
      // autoUpdateOrderReservation() {
      //   if (this.updatingOrderReservation) {
      //     setTimeout(() => {
      //       this.iframeLoaded = true // If user waited so far it also means contract was shown
      //       this.contractStateAttempts += 1
      //       if (!this.updatingOrderReservation) return
      //       this.fetchOrderToUpdateReservation(this.order.id).then(_ => {
      //         if (!this.isChiefRoomGuestSelected) {
      //           // After selected guest switch to identifying state it's completed and the chief is set to go back to the
      //           // guests list
      //           if (this.guestContractFilled(this.selectedGuestUuid)) this.selectedGuestUuid = this.reservation.signer_uuid
      //         }
      //         this.autoUpdateOrderReservation()
      //       })
      //     }, this.contractStateAttemptsFrequency)
      //   }
      // },
      // Tentativo che chiede conferma prima di proseguire e al tempo stesso aggiornare l'ordine... troppo lento
      // checkIfContractIsSigned() {
      //   if (this.contractCompleted) {
      //     this.goToNextStepper()
      //   } else {
      //     // this.fetchOrder(this.order.id).then(_ => {
      //     //   if (this.contractCompleted || confirm('Il contratto non è ancora firmato, sei sicuro?')) {
      //     //     this.goToNextStepper()
      //     //   }
      //     // })
      //     this.fetchOrder(this.order.id)
      //     if (this.contractCompleted || confirm('Il contratto non è ancora firmato, sei sicuro?')) {
      //       this.goToNextStepper()
      //     }
      //   }
      // },
      build_contract_url(uuid) {
        if (!uuid) return
        const url = this.$store.state.application.urls.public_contract_to_sign
        if (!url) return
        return url.replace(':signer_uuid', uuid)
      },
      guestContractFilled(uuid) {
        return !!this.reservation &&  ['signed', 'sent'].includes(this.reservation.guests.find(guest => guest.otpservice_uuid == uuid).otpservice_state)
      },
    },

    channels: {
      GuestsChannel: {
        // connected() { console.log(`Connected to the guests channel ${this.order.uuid}!`) },
        connected() {
          console.log('Connected to the guests channel!')
          this.sock_connected = true
        },
        rejected() {
          console.log('Connection with the guests channel refused :-(')
          this.sock_rejected = true
        },
        received(data) {
          // console.log('Stream from guests channel:', data)
          console.log('Stream from guests channel')
          this.sock_data = data
          if (data.order) {
            this.$store.dispatch('order/updateOrderInOrders', data.order)
          }
          this.sock_received = true
        },
        disconnected() {
          console.log('Left the guests channel :-(')
          this.sock_disconnected = true
        }
      }
    },
  }
</script>

<style lang="scss">
  iframe {
    border-width: 1px;
    border-style: solid;
    border-color: #aaa;
    display:block;
    width:100%;
    height:70vh;
  }
  @media only screen and (max-width: 600px) {
    iframe {
      height:65vh;
    }
  }
</style>
